import { Column, ColumnContent, Empty, Error, GridForm } from "@qw/ui";
import { useInboxFilter } from "@/providers/inbox-filter-provider";
import { useConversations } from "@/providers/use-conversations";
import { useMailHorizonDescription } from "@/providers/use-mail-horizon";
import { AgentCard } from "./agent-card";
import { InboxGroups } from "./inbox-groups";
import { InboxSelectionHeader } from "./inbox-selection-header";

export const Inbox = () => {
  const { conversations, error, loading } = useConversations();
  const { hasSearch } = useInboxFilter();

  // `!error` is redundant with the branch below, which renders the error instead — it is here so a
  // failed list never reaches `foundNothing` and spends the horizon aggregate on it.
  const isEmpty = !error && !loading && conversations.length === 0;
  // Only a search can come back empty for a reason the broker cannot see: mail ingest never
  // reached and mail that ranked badly both render as nothing. An inbox with nothing in it is
  // just empty, and naming the horizon there answers a question nobody asked.
  //
  // `hasSearch` rather than the term, because `subject:renewal` is a search with no term in it —
  // reading the term alone would leave the one search most likely to come back empty unexplained.
  const foundNothing = isEmpty && hasSearch;
  const horizonDescription = useMailHorizonDescription({ skip: !foundNothing });

  return (
    <GridForm data={conversations} className="@container h-full overflow-hidden">
      <Column className="bg-background">
        <InboxSelectionHeader />
        {/* Outside `ColumnContent`, for both of the reasons it is here. It is above the `isEmpty`
            branch below, which returns an `Empty` in place of the whole list and would otherwise
            hide the card in the highest-value case there is: found the person, wanted their
            number, no recent threads. And it stays put while the mail scrolls, for the reason
            `BookScopeRow` does — what a scope *is* must not scroll away with what it
            selected. Renders nothing outside an agent scope. */}
        <AgentCard />
        <ColumnContent>
          {error ? (
            <Error error={error} className="m-3" />
          ) : isEmpty ? (
            <Empty
              icon="inbox"
              title="No conversations found"
              description={horizonDescription ?? "Your inbox is empty."}
            />
          ) : (
            <InboxGroups />
          )}
        </ColumnContent>
      </Column>
    </GridForm>
  );
};
